/* eslint-disable */
export const init = (callback) => {
    // Facebook login
    window.fbAsyncInit = function () {
        FB.init({
            appId: process.env.FACEBOOK_APP_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: process.env.FACEBOOK_APP_VERSION
        })
    }

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0]
            if (d.getElementById(id)) {
                return
            }
            js = d.createElement(s)
            js.id = id
            js.src = "https://connect.facebook.net/en_US/sdk.js"
            fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'facebook-jssdk'))
    callback()
}
export const getStatus = (callback) => {
    FB.getLoginStatus((response) => callback(response))
}
export const login = (callback) => {
    FB.login((response) => callback(response), { scope: 'public_profile, email, leads_retrieval, pages_show_list, pages_manage_ads, pages_manage_metadata, pages_read_engagement' })
}
export const logout = (callback) => {
    FB.logout((response) => callback(response))
}
export const getName = (id, callback) => {
    FB.api(
        `/${id}`,
        (response) => callback(response)
    )
}
export const getBigToken = (token, callback) => {
    FB.api(
        `/oauth/access_token`,
        {
            grant_type: 'fb_exchange_token',
            client_id: process.env.FACEBOOK_APP_ID,
            client_secret: process.env.FACEBOOK_APP_SECRET,
            fb_exchange_token: token,
        },
        (response) => callback(response)
    )
}
export const getPages = (user, callback) => {
    FB.api(
        `/${user.id}/accounts`,
        { access_token: user.accessToken },
        (response) => callback(response)
    )
}
export const getForms = (page, callback) => {
    FB.api(
        `/${page.id}/leadgen_forms`,
        { access_token: page.accessToken, limit: 500 },
        (response) => callback(response)
    )
}
export const getQualifiers = (formId, pageToken, callback) => {
    FB.api(
        `/${formId}`,
        { access_token: pageToken, fields: 'questions' },
        (response) => callback(response)
    )
}
export const setSubscribedApps = (page) => {
    FB.api(
        `/${page.id}/subscribed_apps`,
        'post',
        { access_token: page.accessToken, subscribed_fields: 'leadgen' }
    )
}



// WEBPACK FOOTER //
// ./src/services/facebook.js